import {
  Section,
  Alert,
  Heading,
  Content,
} from "@mittwald/flow-remote-react-components";
import { Suspense } from "react";
import { ImageCompression } from "../components/ImageCompression.tsx";
import { ImageCompressionSkeleton } from "../components/ImageCompressionSkeleton.tsx";
import { useConfig } from "@mittwald/ext-bridge/react";
import { useProject } from "../hooks/useProject.ts";

export const ImageCompressionEditor = () => {
  const config = useConfig();

  const appInstallationId = config.appInstallationId;
  if (!appInstallationId) {
    throw new Error("appInstallationId is not defined");
  }

  const projectId = config.projectId;
  if (!projectId) {
    throw new Error("projectId is not defined");
  }

  const project = useProject(projectId);

  const appInstallation = project.data.appInstallations.find(
    (a) => a.id == appInstallationId,
  );

  if (!appInstallation) {
    throw new Error("app installation not found in project");
  }

  if (!appInstallation.phpVersion) {
    return (
      <Section>
        <Alert status="info">
          <Heading>Kein PHP installiert</Heading>
          <Content>
            Die Bildkomprimierung funktioniert nur mit PHP-Apps. In deiner App
            ist keine PHP-Version installiert. Wenn du die Bildkomprimierung
            nutzen möchtest, wechsle bitte zu einer PHP-App oder installiere PHP
            über den Tab &quot;Software&quot;.
          </Content>
        </Alert>
      </Section>
    );
  }

  return (
    <Suspense
      fallback={
        <Section>
          <ImageCompressionSkeleton />
        </Section>
      }
    >
      <ImageCompression />
    </Suspense>
  );
};
